module.exports = __webpack_public_path__ + "static/testi-2-cd620d90595a5e50bd99de1f1b714bf2.jpg";